import { SVGProps, Ref, forwardRef } from 'react';

export const HyperstarSparkleFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M6 4c1.5 2.25 3.75 4.5 6 6-2.25 1.5-4.5 3.75-6 6-1.5-2.25-3.75-4.5-6-6 2.25-1.5 4.5-3.75 6-6"
                        fill="currentColor"
                    />
                    <path
                        d="M12.666 0C13.499 1.25 14.75 2.5 16 3.333c-1.25.833-2.5 2.084-3.334 3.334a12.7 12.7 0 0 0-3.333-3.334A12.7 12.7 0 0 0 12.666 0"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
HyperstarSparkleFilledSize16Glyph.displayName = 'HyperstarSparkleFilledSize16Glyph';
